import React, { memo } from "react";
import { Icon, IconProps } from "@chakra-ui/icon";

const FileBoxIcon = (props: IconProps) => (
  <Icon
    width="16px"
    height="16px"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M13.3333 1.33337H2.66668c-.66667 0-1.33334.6-1.33334 1.33334v2.00666c0 .48.28667.89334.66667 1.12667v7.53336c0 .7333.73333 1.3333 1.33333 1.3333h9.33336c.6 0 1.3333-.6 1.3333-1.3333V5.80004c.38-.23333.6667-.64667.6667-1.12667V2.66671c0-.73334-.6667-1.33334-1.3334-1.33334Zm-.6666 12.00003H3.33334V6.00004h9.33336v7.33336Zm.6666-8.66669H2.66668v-2H13.3333v2Z" />
    <path d="M10 8.00004H6.00001v1.33333H10V8.00004Z" />
  </Icon>
);

export default memo(FileBoxIcon);
